module.exports = __webpack_public_path__ + "images/help/logo@2x-5ff7ada62161b6e600b3017dd26b9982.png";